import axios from 'axios';
import { showError } from '../utils';
import config from '../config';

function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success' || resp.status === 200) {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

/**
 * Fetch Joye intro data
 */
export function joyeIntro(authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.joyeServer}/joye/intro`,
    headers,
  });
}

/**
 * Fetch Joye dashboard data
 */
export function joyeDashboard(authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.joyeServer}/joye/dashboard`,
    headers,
  });
}

/**
 * Fetch mood logs for a given month
 * @param {number} year
 * @param {number} month
 */
export function getMoodLogs(authToken, year, month) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.joyeServer}/joye/mood-logs`,
    headers,
    params: { year, month },
  });
}

/**
 * Fetch mood summary for a specific date
 * @param {string} date - Format: DD-MM-YYYY
 */
export function getMoodSummary(authToken, date) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.joyeServer}/joye/mood-summary`,
    headers,
    params: { date },
  });
}

/**
 * Fetch Fitcoin summary
 */
export function getFitCoinSummary(authToken) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.joyeServer}/joye/fitcoin-summary`,
    headers,
  });
}
